import React from 'react'
import { CFooter } from '@coreui/react'

const TheFooter = () => {
  return (
    <CFooter fixed={false}>
      <div>
        <span className="ml-1">&copy; Version 1.0</span>
      </div>
      <div className="mfs-auto">
        <span className="mr-1">EFW Drive Scanner</span>
        {/* <a href="http://efwsolutions.com" target="_blank" rel="noopener noreferrer">EFW Scanner</a> */}
      </div>
    </CFooter>
  )
}

export default React.memo(TheFooter)
